export default __webpack_public_path__ + "static/media/baby.9065eafa.png";